export default "__VITE_ASSET__fffd5ab0__"